<template>
  <div class="mt-1 flex flex-col gap-1">
    <QBtn
      v-for="nav in navs"
      :to="nav.route"
      dense
      :color="$q.dark.isActive?'dark-1':'light-3'"
    >
      <div class="w-full px-4 py-1 text-sm dark:text-dark-text light:text-light-text flex items-center justify-start gap-5">
        <SvgIcon
          :name="nav.icon"
          size="xs"
        />
        {{ nav.label }}
        <div v-if="nav.count && nav.count.value > 0">
          ({{ nav.count }})
        </div>
      </div>
    </QBtn>
  </div>
</template>

<script setup>
import SvgIcon from '@/components/Icons/SvgIcon.vue'

const navs = [
  {
    icon: 'questions',
    label: '고객센터',
    route: { name: 'questions' }
  },
  {
    icon: 'bets',
    label: '배팅내역',
    route: { name: 'bets', params: { category: 'pregame' } }
  },
  {
    icon: 'announcements',
    label: '공지사항',
    route: { name: 'announcements' }
  },
  {
    icon: 'attendances',
    label: '출석체크',
    route: { name: 'attendances' }
  },

  // {
  //   icon: 'deposits',
  //   label: '충전',
  //   route: { name: 'deposits' }
  // },
  // {
  //   icon: 'withdrawals',
  //   label: '환전',
  //   route: { name: 'withdrawals' }
  // },
  // {
  //   icon: 'events',
  //   label: '이벤트',
  //   route: { name: 'events' }
  // },
  // {
  //   icon: 'consumables',
  //   label: '아이템',
  //   route: { name: 'consumables' },
  //   count: computed(() => sum(map(authStore.user.consumables, v => v.count)))
  // },
  // {
  //   icon: 'messages',
  //   label: '쪽지함',
  //   route: { name: 'messages' },
  //   count: computed(() => authStore.user.new_messages_count),
  // },
  // {
  //   icon: 'coupons',
  //   label: '쿠폰',
  //   route: { name: 'coupons' },
  //   count: computed(() => authStore.user.coupons.length),
  // },
  //
  // {
  //   icon: 'exchanges',
  //   label: '포인트',
  //   route: { name: 'exchanges' }
  // },
  // {
  //   icon: 'threads',
  //   label: '게시판',
  //   route: { name: 'threads' }
  // },
  // {
  //   icon: 'lottery-wheel',
  //   label: '스핀룰렛',
  //   route: { name: 'lottery.wheel' }
  // }
]
</script>
